module.exports = __webpack_public_path__ + "media/images/thumbnails/thumb2-bf0e57393282bb375ba59d4995ad1102.jpg";